<template>
    <b-modal
        v-model="isShown"
        centered
        lazy
    >

        <template slot="modal-title">
            Edit Currency - {{ currency.label }}
        </template>

        <b-container fluid>
            <b-row>
                <b-form-group class="mb-0 w-100">
                    <div><label>Exchange Rate</label></div>
                    <b-form-input
                        v-model.trim="$v.currency.exchangeRate.$model"
                        type="text"
                        :value="currency.exchangeRate"
                        @blur.native="formatExchangeRate"
                    />
                    <b-form-invalid-feedback :force-show="$v.currency.exchangeRate.$dirty && !$v.currency.exchangeRate.required">
                        The exchange rate is required.
                    </b-form-invalid-feedback>
                    <b-form-invalid-feedback :force-show="$v.currency.exchangeRate.$dirty && !$v.currency.exchangeRate.decimal">
                        The exchange rate must be a decimal value.
                    </b-form-invalid-feedback>
                </b-form-group>
            </b-row>
        </b-container>

        <div
            slot="modal-footer"
            class="d-flex justify-content-between w-100"
        >
            <div>
                <Button
                    variant="danger"
                    :loading="deleteLoading"
                    @click="handleDelete()"
                >
                    Delete
                </Button>
            </div>
            <div>
                <b-btn
                    variant="default"
                    class="mr-2"
                    @click="reset()"
                >
                    Close
                </b-btn>
                <Button
                    variant="success"
                    :disabled="$v.$invalid"
                    :loading="submitLoading"
                    @click="handleSubmit()"
                >
                    Save Currency
                </Button>
            </div>
        </div>

    </b-modal>
</template>

<script>
import { required, decimal } from 'vuelidate/lib/validators';
import { formatFloat } from '@/utils/helpers';

export default {

    data() {
        return {
            isShown: false,
            submitLoading: false,
            deleteLoading: false,
            currency: {
                currency_id: null,
                label: '',
                exchangeRate: null,
            },
        };
    },

    validations: {
        currency: {
            exchangeRate: {
                required,
                decimal,
            },
        },
    },

    created() {
        this.$eventBus.$on(this.$events.openEditCurrencyModal, (e) => {
            this.currency.currency_id = e.currencyId;
            this.currency.label = e.label;
            this.currency.exchangeRate = e.exchangeRate;
            this.isShown = true;
        });
    },

    methods: {
        async handleSubmit() {
            this.submitLoading = true;
            await this.$store.dispatch('costable/updateCurrency', {
                currencyId: this.currency.currency_id,
                exchangeRate: this.currency.exchangeRate,
            });
            this.submitLoading = false;
            this.reset();
        },
        async handleDelete() {
            this.deleteLoading = true;
            await this.$store.dispatch('costable/deleteCurrency', this.currency.currency_id);
            this.deleteLoading = false;
            this.reset();
        },
        formatExchangeRate() {
            this.exchangeRate = formatFloat(this.exchangeRate, 4);
        },
        reset() {
            this.isShown = false;
            this.currency.label = '';
            this.currency.exchangeRate = null;
            this.$nextTick(() => {
                this.$v.$reset();
            });
        },
    },

};
</script>
